import type { GetSchedule, MeetingType } from "@/api_types/teacher";

export const virtualTypesArr = ["url", "zoom", "google", "teams"] as const;

export const virtualTypes = {
  url: "virtual_room",
  zoom: "zoom_link",
  google: "google_meet_url",
  teams: "microsoft_teams_url"
} as const;

export const getMeetingUrlProperty = (
  meeting_types: MeetingType | undefined,
  meeting: GetSchedule
): (typeof virtualTypes)[keyof typeof virtualTypes] | "" => {
  const virtual_type = meeting_types?.virtual_type || "url";
  if (meeting[virtualTypes[virtual_type]]) return virtualTypes[virtual_type];
  // for (const key of virtualTypesArr) {
  //   if (meeting[virtualTypes[key]]) return virtualTypes[key];
  // }
  return "";
};

export const getMeetingType = (meeting_types: MeetingType | undefined, meeting: GetSchedule) => {
  const property = getMeetingUrlProperty(meeting_types, meeting);
  if (property == virtualTypes.google) return "Google Meet";
  if (property == virtualTypes.zoom) return "Zoom";
  if (property == virtualTypes.url) return "Virtual Link";
  if (property == virtualTypes.teams)
    return meeting.microsoft_teams_url.includes("skype") ? "Microsoft Skype" : "Microsoft Teams";
  if (!meeting_types?.virtual_type || meeting_types?.virtual_type == "url")
    return "Link not Specified";
  if (
    meeting_types.virtual_type == "google" &&
    meeting.google_calendar_connected != null &&
    Number(meeting.google_calendar_connected) === 0
  )
    return "Link pending: teacher must reconnect Google Calendar";
  return "Link generation in progress";
};
